import { __assign } from "tslib";
import React, { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import Paginacion from './Paginacion';
export default function Body(_b) {
    var children = _b.children, col = _b.col, row = _b.row, mostrar = _b.mostrar, itens = _b.itens;
    var _c = useState(1), page = _c[0], setPage = _c[1];
    useEffect(function () { return setPage(1); }, [itens.length]);
    function filter(_a, i) {
        var init = (page - 1) * mostrar, fin = init + mostrar;
        return i >= init && i < fin;
    }
    function getRef(_b) {
        var codigo = _b.codigo, id = _b.id, status = _b.status, estado = _b.estado, estatus = _b.estatus;
        var key = 'key';
        if (status)
            key += status;
        if (estado)
            key += estado;
        if (estatus)
            key += estatus;
        if (codigo)
            key += codigo;
        if (id)
            key += id;
        if (key === 'key')
            return key + Math.random();
        return key;
    }
    function Row(d) {
        return React.createElement(React.Fragment, null, row(d));
    }
    function BodyContent() {
        var iten = itens.filter(filter);
        return (React.createElement(React.Fragment, null, iten.map(function (it) { return (React.createElement(Row, __assign({ key: getRef(it) }, it))); })));
    }
    return (React.createElement(Table, { striped: true, hover: true },
        React.createElement("thead", null, children),
        React.createElement("tbody", { key: 'mostrar' + page },
            React.createElement(BodyContent, null)),
        React.createElement("tr", null,
            React.createElement("td", { colSpan: col },
                React.createElement(Paginacion, { page: page, length: itens.length, mostrar: mostrar, setpage: setPage })))));
}
//# sourceMappingURL=Body.js.map